<template>
  <div class="text-2xl font-medium md:inset-x-0 md:m-auto md:max-w-screen-xl">
    <div class="md:divide-y">
      <AccordionProductDescriptionEntry
        id="product-details-about"
        :about="aboutAttributes"
        variant="narrow"
        default-open-preview
      />

      <SFAccordionEntry id="product-details-instructions">
        <template #title>
          <h2>
            {{ $t('product_details.information.material_and_instructions') }}
          </h2>
        </template>
        <div class="mt-2 flex flex-col gap-2 md:mt-4">
          <ul
            v-for="attr in materialAttributes"
            :key="attr?.key"
            class="list-none"
          >
            <li
              v-for="val in attr?.values"
              :key="val"
              class="ml-10 flex items-start gap-2 py-3 text-lg"
            >
              {{ attr?.label }}:
              <div v-safe-html="sanitizeHtml(val)" class="font-normal"></div>
            </li>
          </ul>
        </div>
      </SFAccordionEntry>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'
import { defineAsyncComponent, hydrateOnVisible, toRef } from 'vue'
import { SFAccordionEntry } from '#storefront-ui/components'
import { useProductAttributes } from '~/utils/attributes'
import { sanitizeHtml } from '~/utils/sanitize'

const AccordionProductDescriptionEntry = defineAsyncComponent({
  loader: () =>
    import('~/components/product/detail/AccordionProductDescriptionEntry.vue'),
  hydrate: hydrateOnVisible(),
})

// These are the keys we want to show under each accordion
const aboutKeys = [
  'description',
  'features',
  'manufacturerColor',
  'genders',
  'productType',
  'articleNo',
  'productCode',
  'manufacturerCode',
  'brand_address',
]

const materialKeys = [
  'innerMaterial',
  'outerMaterial',
  'outsole',
  'innerSole',
  'material',
]

const props = defineProps<{ product: Product }>()
const product = toRef(props, 'product')

const aboutAttributes = useProductAttributes(product, aboutKeys)
const materialAttributes = useProductAttributes(product, materialKeys)
</script>
